import { useState } from "react";

function DashboardMockup() {
  return (
    <svg
      viewBox="0 0 620 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "100%", height: "auto", borderRadius: 20 }}
    >
      {/* Outer card */}
      <rect width="620" height="480" rx="20" fill="#1a1730" />

      {/* Nav bar */}
      <rect width="620" height="64" rx="0" fill="#1e1b38" />
      <rect y="0" width="620" height="64" rx="20" fill="#1e1b38" />
      <rect y="44" width="620" height="20" fill="#1e1b38" />
      {/* Welcome back */}
      <text x="36" y="120" fill="#a78bfa" fontSize="26" fontWeight="800" fontFamily="sans-serif">Welcome back, Peter!</text>

      {/* Recently Created label */}
      <text x="36" y="162" fill="#9ca3af" fontSize="13" fontFamily="sans-serif">Recently Created</text>

      {/* Card 1 */}
      <rect x="36" y="180" width="250" height="160" rx="14" fill="#13121f" stroke="#3d3860" strokeWidth="1" />
      {/* RADAR badge */}
      <rect x="50" y="196" width="58" height="22" rx="11" fill="#252340" />
      <text x="60" y="212" fill="#a78bfa" fontSize="10" fontWeight="bold" fontFamily="monospace">RADAR</text>
      {/* BTC icon */}
      <text x="264" y="214" fill="#f7931a" fontSize="18" fontFamily="monospace">₿</text>
      {/* Address */}
      <text x="50" y="262" fill="#ffffff" fontSize="14" fontWeight="700" fontFamily="monospace">opqrst...987654</text>
      <text x="50" y="282" fill="#9ca3af" fontSize="12" fontFamily="sans-serif">Tracking for VASP Operation</text>
      {/* Divider */}
      <line x1="50" y1="308" x2="274" y2="308" stroke="#3d3860" strokeWidth="1" />
      {/* Dot + time */}
      <circle cx="58" cy="325" r="5" fill="#7c3aed" />
      <text x="70" y="329" fill="#9ca3af" fontSize="11" fontFamily="sans-serif">Updated yesterday at 13:12</text>
      {/* Three dots */}
      <text x="265" y="329" fill="#9ca3af" fontSize="18">⋮</text>

      {/* Card 2 */}
      <rect x="306" y="180" width="250" height="160" rx="14" fill="#13121f" stroke="#3d3860" strokeWidth="1" />
      {/* PULSE badge */}
      <rect x="320" y="196" width="58" height="22" rx="11" fill="#252340" />
      <text x="330" y="212" fill="#a78bfa" fontSize="10" fontWeight="bold" fontFamily="monospace">PULSE</text>
      {/* Address */}
      <text x="320" y="262" fill="#ffffff" fontSize="14" fontWeight="700" fontFamily="monospace">bC1rst...9dwEn3</text>
      <text x="320" y="282" fill="#9ca3af" fontSize="12" fontFamily="sans-serif">Report 329</text>
      {/* Divider */}
      <line x1="320" y1="308" x2="544" y2="308" stroke="#3d3860" strokeWidth="1" />
      {/* Dot + time */}
      <circle cx="328" cy="325" r="5" fill="#7c3aed" />
      <text x="340" y="329" fill="#9ca3af" fontSize="11" fontFamily="sans-serif">Created on 2022-10-...</text>
    </svg>
  );
}

const steps = [
  {
    num: "01",
    title: "Elevated API delivery",
    desc: "Whether through our comprehensive API or bulk egress, get empowered access for observation and modeling to tell the data story, mitigate risks, and identify critical investment opportunities for your organization.",
  },
  {
    num: "02",
    title: "Enhanced Block Explorer",
    desc: "Organize and enrich blockchain data to deliver precise attribution and beneficial ownership insights. Featuring robust clustering, root address identification, and custom tagging capabilities, organizations can accurately track the flow of funds and gain unparalleled visibility into complex networks.",
  },
  {
    num: "03",
    title: "Intuitive mapping",
    desc: "Powered by SourceFlow, our dynamic visualization tool transforms complex on-chain data into graphical representations for actionable insights to support risk modeling, market opportunities, and investigations.",
  },
];

function DotGrid() {
  const dots = [];
  const cols = 4, rows = 5;
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const highlighted = (r === 2 && c === 0) || (r === 4 && c === 1);
      dots.push(
        <circle
          key={`${r}-${c}`}
          cx={c * 52 + 26}
          cy={r * 52 + 26}
          r={highlighted ? 20 : 15}
          fill={highlighted ? "#a78bfa" : "#ddd6fe"}
          opacity={highlighted ? 1 : 0.45 + c * 0.13}
        />
      );
    }
  }
  return (
    <svg viewBox="0 0 240 280" style={{ width: "100%", maxWidth: 210, height: "auto" }}>
      {dots}
    </svg>
  );
}

function ArrowIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );
}

function StepRow({ s, i, isLast }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        gap: "20px 32px",
        padding: "clamp(28px, 4vw, 52px) 0",
        borderBottom: isLast ? "none" : "1px solid #000",
        cursor: "default",
        transition: "background 0.2s",
      }}
    >
      <span style={{
        fontFamily: "monospace",
        fontSize: "clamp(0.85rem, 1.5vw, 1.05rem)",
        fontWeight: 700,
        color: hovered ? "#ffffff" : "#7c3aed",
        background: hovered ? "#7c3aed" : "transparent",
        letterSpacing: "0.05em",
        border: "1.5px solid #a78bfa",
        borderRadius: 8,
        padding: "4px 10px",
        display: "inline-flex",
        alignItems: "center",
        height: "fit-content",
        marginTop: 4,
        transition: "background 0.3s, color 0.3s",
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}>
        {s.num}
      </span>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 220px), 1fr))",
        gap: "12px 40px",
        alignItems: "center",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <h3 style={{
            fontSize: "clamp(1.3rem, 2.5vw, 2.2rem)",
            fontWeight: 400,
            color: "#0f0f1a",
            margin: 0,
            letterSpacing: "-0.01em",
            lineHeight: 1.2,
            transition: "color 0.2s",
          }}>
            {s.title}
          </h3>
         
        </div>

        <p style={{
          color: "#4b5563",
          fontSize: "clamp(0.85rem, 1.3vw, 0.95rem)",
          lineHeight: 1.75,
          margin: 0,
        }}>
          {s.desc}
        </p>
      </div>
    </div>
  );
}

export default function About() {
  return (
    <div style={{ background: "#ffffff", color: "#0f0f1a" }}>

      {/* ── SECTION 1: How elementuslabs simplifies ── */}
      <section style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 340px), 1fr))",
        minHeight: "clamp(400px, 60vh, 80vh)",
        overflow: "hidden",
      }}>
        {/* Left: dark dashboard panel */}
        <div style={{
          background: "#f8f8fc",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "clamp(24px, 4vw, 48px) clamp(16px, 3vw, 40px)",
          minHeight: "clamp(320px, 45vw, 560px)",
        }}>
          <div style={{ width: "100%", maxWidth: 560 }}>
            <DashboardMockup />
          </div>
        </div>

        {/* Right: headline + body */}
        <div style={{
          background: "#f8f8fc",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "clamp(40px, 6vw, 80px) clamp(20px, 5vw, 72px)",
        }}>
          {/* "How elementuslabs" heading */}
          <h2 style={{
            fontSize: "clamp(2.4rem, 5.5vw, 5rem)",
            fontWeight: 600,
            color: "#0f0f1a",
            margin: "0 0 clamp(16px, 2.5vw, 28px)",
            lineHeight: 1.05,
            letterSpacing: "-0.025em",
            fontFamily: "'Georgia', serif",
          }}>
            How elementuslabs
          </h2>

          {/* "simplifies" pill */}
          <div style={{ marginBottom: "clamp(28px, 4vw, 52px)" }}>
            <span style={{
              display: "inline-block",
              fontSize: "clamp(2.4rem, 5.5vw, 5rem)",
              fontWeight: 600,
              color: "#7c3aed",
              border: "2.5px solid #a78bfa",
              borderRadius: "999px",
              padding: "2px 32px 10px",
              lineHeight: 1.15,
              letterSpacing: "-0.02em",
              fontFamily: "'Georgia', serif",
            }}>
              simplifies
            </span>
          </div>

          <p style={{
            color: "#4b5563",
            fontSize: "clamp(0.9rem, 1.5vw, 1.05rem)",
            lineHeight: 1.8,
            maxWidth: 460,
            margin: 0,
          }}>
            By combining the most comprehensive data set available with our patented algorithms,
            elementuslabs enables organizations to discover valuable market intelligence, investigate on-chain
            activity, identify risk, and create new revenue opportunities.
          </p>
        </div>
      </section>

      {/* ── SECTION 2: Numbered feature list ── */}
      <section style={{
        background: "#ffffff",
        padding: "clamp(20px, 4vw, 40px) clamp(16px, 6vw, 80px)",
        maxWidth: 1400,
        margin: "0 auto",
        boxSizing: "border-box",
      }}>
        {steps.map((s, i) => (
          <StepRow key={i} s={s} i={i} isLast={i === steps.length - 1} />
        ))}
      </section>

      {/* ── SECTION 3: Unlock the full picture ── */}
      <section style={{
        background: "#f8f7ff",
        padding: "clamp(48px, 8vw, 100px) clamp(16px, 6vw, 80px)",
        boxSizing: "border-box",
      }}>
        <div style={{ marginBottom: "clamp(24px, 4vw, 48px)" }}>
          <span style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: "#ede9fe",
            color: "#4b5563",
            fontSize: "0.75rem",
            fontWeight: 600,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            padding: "6px 14px",
            borderRadius: 6,
          }}>
            About Us
          </span>
        </div>

        <h2 style={{
          fontSize: "clamp(2rem, 5vw, 4rem)",
          fontWeight: 600,
          color: "#0f0f1a",
          margin: "0 0 clamp(40px, 6vw, 72px)",
          letterSpacing: "-0.025em",
          lineHeight: 1.1,
          fontFamily: "'Georgia', serif",
        }}>
          Unlock the{" "}
          <span style={{
            color: "#7c3aed",
            border: "2.5px solid #a78bfa",
            borderRadius: "999px",
            padding: "2px 22px 6px",
            display: "inline-block",
          }}>
            full picture
          </span>{" "}
          of the blockchain
        </h2>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 260px), 1fr))",
          gap: "clamp(32px, 5vw, 0px) 80px",
          alignItems: "center",
          maxWidth: 1200,
        }}>
          <div style={{
            display: "flex",
            justifyContent: "flex-start",
            paddingLeft: "clamp(0px, 2vw, 20px)",
          }}>
            <DotGrid />
          </div>

          <div>
            <p style={{
              color: "#374151",
              fontSize: "clamp(0.9rem, 1.5vw, 1.05rem)",
              lineHeight: 1.85,
              margin: "0 0 32px",
            }}>
              elementuslabs was founded out of a genuine passion for solving blockchain's toughest challenges. We believe
              that the key to unlocking the true potential of digital assets lies in robust, reliable on-chain data—the
              foundation for any meaningful analysis. By harnessing our patented technology and deep expertise, we
              provide unparalleled transparency and insights that help businesses accurately assess risk and capitalize
              on opportunities in an evolving digital economy.
            </p>

     
          </div>
        </div>
      </section>
    </div>
  );
}